import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs/Observable'

import { getRangeFromDateFilter } from 'utils/dateUtils'

import { addToast } from '../Toasts/actions'

import { EDIT_TENANT_APPLY_ASYNC } from './EditTenant/constants'
import editTenantEpics from './EditTenant/epics'
import {
  addCompanyError,
  addCompanySuccess,
  fetchCompaniesError,
  fetchCompaniesSuccess,
  fetchPartnerIncidentsError,
  fetchPartnerIncidentsSuccess,
  fetchPartnerStatisticsError,
  fetchPartnerStatisticsSuccess,
} from './actions'
import {
  COMPANIES_FILTER_CHANGE,
  COMPANIES_PAGE_CHANGE,
  FETCH_POSSIBLE_ACQUIRING_PARTNERS_ASYNC,
  INCIDENTS_FILTER_CHANGE,
  MIGRATE_COMPANY_ASYNC,
  NEW_COMPANY_ADD_ASYNC,
  PARTNER_COMPANIES_GET_ASYNC,
  PARTNER_INCIDENTS_GET_ASYNC,
  PARTNER_STATISTICS_GET_ASYNC,
  SEARCH_CHANGE,
  SORT_PROPERTY_CHANGE,
} from './constants'
import {
  selectCompaniesFilter,
  selectPage,
  selectSearch,
  selectSortProperty,
  selectTimeFilter,
} from './selectors'

const fetchCompaniesEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$
    .ofType(
      NEW_COMPANY_ADD_ASYNC.SUCCESS,
      EDIT_TENANT_APPLY_ASYNC.SUCCESS,
      PARTNER_COMPANIES_GET_ASYNC.INITIATE,
      COMPANIES_PAGE_CHANGE,
      COMPANIES_FILTER_CHANGE,
      SEARCH_CHANGE,
      SORT_PROPERTY_CHANGE,
      MIGRATE_COMPANY_ASYNC.SUCCESS
    )
    .switchMap(() => {
      const state = store.getState()
      return api.msp
        .getPartnerCompanies(
          selectPage(state),
          selectSortProperty(state),
          selectCompaniesFilter(state),
          selectSearch(state)
        )
        .map((response) => fetchCompaniesSuccess(response))
        .catch((error) => Observable.of(epicsErrorHandler(fetchCompaniesError, error, [400])))
    })

const addCompanyEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$.ofType(NEW_COMPANY_ADD_ASYNC.INITIATE).mergeMap((action) =>
    api.msp
      .addPartnerCompany(action.payload.data)
      .mergeMap((response) => {
        window.closeModal()
        return Observable.of(
          addCompanySuccess(response),
          addToast({ message: 'Company was successfully added!' })
        )
      })
      .catch((error) => Observable.of(epicsErrorHandler(addCompanyError, error, [400])))
  )

const fetchPartnerIncidentsEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$.ofType(PARTNER_INCIDENTS_GET_ASYNC.INITIATE, INCIDENTS_FILTER_CHANGE).mergeMap(() =>
    api.msp
      .getPartnerIncidents(getRangeFromDateFilter(selectTimeFilter(store.getState())))
      .map(({ response }) => fetchPartnerIncidentsSuccess(response))
      .catch((error) => Observable.of(epicsErrorHandler(fetchPartnerIncidentsError, error)))
      .takeUntil(action$.ofType(PARTNER_INCIDENTS_GET_ASYNC.CANCEL))
  )

const fetchPartnerStatisticsEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$
    .ofType(
      PARTNER_STATISTICS_GET_ASYNC.INITIATE,
      NEW_COMPANY_ADD_ASYNC.SUCCESS,
      EDIT_TENANT_APPLY_ASYNC.SUCCESS
    )
    .mergeMap(() =>
      api.msp
        .getPartnerStatistics()
        .map((response) => fetchPartnerStatisticsSuccess(response))
        .catch((error) => Observable.of(epicsErrorHandler(fetchPartnerStatisticsError, error)))
        .takeUntil(action$.ofType(PARTNER_STATISTICS_GET_ASYNC.CANCEL))
    )

const fetchPossibleAcquiringPartnersEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$.ofType(FETCH_POSSIBLE_ACQUIRING_PARTNERS_ASYNC.INITIATE).mergeMap(() =>
    api.msp
      .fetchPossibleAcquiringPartners()
      .mergeMap((response) =>
        Observable.of(
          FETCH_POSSIBLE_ACQUIRING_PARTNERS_ASYNC.onSuccess(
            response.possible_acquiring_company_brands
          )
        )
      )
      .catch((error) =>
        Observable.of(epicsErrorHandler(FETCH_POSSIBLE_ACQUIRING_PARTNERS_ASYNC.onError, error))
      )
      .takeUntil(action$.ofType(FETCH_POSSIBLE_ACQUIRING_PARTNERS_ASYNC.CANCEL))
  )

const migrateCompanyEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$.ofType(MIGRATE_COMPANY_ASYNC.INITIATE).mergeMap((action) =>
    api.msp
      .migrateCompany(
        action.payload.releasingBrandId,
        action.payload.acquiringBrandId,
        action.payload.companyId
      )
      .mergeMap((response) =>
        Observable.of(
          addToast({
            id: 'Migrate_company_Success',
            message: (
              <span id="Migrate_company_Success">
                Tenant {action.payload.companyName} was updated successfully
              </span>
            ),
          }),
          MIGRATE_COMPANY_ASYNC.onSuccess(response)
        )
      )
      .catch((error) =>
        Observable.of(
          addToast({
            type: 'error',
            id: 'Migrate_company_Error',
            message: (
              <span id="Migrate_company_Error">
                We were unable to update the tenant plan to {action.payload.companyName}
                <a href="https://support.ironscales.com/hc/en-us/requests/new">
                  Contact customer Success
                </a>
                )
              </span>
            ),
          }),
          epicsErrorHandler(() => MIGRATE_COMPANY_ASYNC.onError(action.payload.companyId), error)
        )
      )
      .takeUntil(action$.ofType(MIGRATE_COMPANY_ASYNC.CANCEL))
  )

export default combineEpics(
  combineEpics(
    fetchCompaniesEpic,
    addCompanyEpic,
    fetchPartnerIncidentsEpic,
    fetchPartnerStatisticsEpic,
    migrateCompanyEpic,
    fetchPossibleAcquiringPartnersEpic
  ),
  editTenantEpics
)
